"use client";

import { PDFCacheProvider } from "@/contexts/pdf-cache-context";
import { EncryptionPasswordProvider } from "@/contexts/encryption-password-context";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AppNavigation } from "./components/app-navigation";

export function AppLayoutClient({ children }: { children: React.ReactNode }) {
  return (
    <EncryptionPasswordProvider>
      <PDFCacheProvider>
        <TooltipProvider delayDuration={0}>
          <AppNavigation>
            <div className="flex min-h-full flex-col">
              <div className="flex-1">{children}</div>
            </div>
          </AppNavigation>
        </TooltipProvider>
      </PDFCacheProvider>
    </EncryptionPasswordProvider>
  );
}
